export const infoPageModule = {
  name: 'Info Page',
};
